import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    email: '',
    name: '',
    company: '',
    address: '',
    tel: '',
    payment: {},
    receipt: {},
    admin: false
  },
  getters: {
    email(state) {
      return state.email
    },
    name(state) {
      return state.name
    },
    company(state) {
      return state.company
    },
    address(state) {
      return state.address
    },
    tel(state) {
      return state.tel
    },
    payment(state) {
      return state.payment
    },
    receipt(state) {
      return state.receipt
    },
    admin(state) {
      return state.admin
    }
  },
  mutations: {
    setEmail(state, email) {
      state.email = email
    },
    setName(state, name) {
      state.name = name
    },
    setCompany(state, company) {
      state.company = company
    },
    setAddress(state, address) {
      state.address = address
    },
    setTel(state, tel) {
      state.tel = tel
    },
    setPayment(state, payment) {
      state.payment = payment
    },
    setReceipt(state, receipt) {
      state.receipt = receipt
    },
    setAdmin(state, admin) {
      state.admin = admin
    }
  },
  actions: {
    updateEmail({ commit }, payload) {
      commit('setEmail', payload)
    },
    updateName({ commit }, payload) {
      commit('setName', payload)
    },
    updateCompany({ commit }, payload) {
      commit('setCompany', payload)
    },
    updateAddress({ commit }, payload) {
      commit('setAddress', payload)
    },
    updateTel({ commit }, payload) {
      commit('setTel', payload)
    },
    updatePayment({ commit }, payload) {
      commit('setPayment', payload)
    },
    updateReceipt({ commit }, payload) {
      commit('setReceipt', payload)
    },
    updateAdmin({ commit }, payload) {
      commit('setAdmin', payload)
    }
  }
})
